export default __webpack_public_path__ + "static/media/avatar.4a6d0617.png";